import { useQuery } from '@tanstack/react-query';
import { queryFn, getSankeyDataKey, PeriodType } from './queryFn';

export type ParamsType = {
  canonicalUrl: string;
  period?: PeriodType;
};

export const useSankeyData = ({ canonicalUrl, period = '1Y' }: ParamsType) => {
  const { data, status } = useQuery({
    queryKey: getSankeyDataKey({ canonicalUrl, period }),
    queryFn,
    staleTime: 3600000,
    enabled: !!canonicalUrl && !!period,
  });

  return { status, data };
};
